export default __webpack_public_path__ + "static/media/firedUserAvatar.e2907b96.svg";